import { ProductInboundTransactionDoc, ProductOutboundTransactionDoc } from '@gooduncles/gu-app-schema';
import { Empty } from 'antd';
import { FC } from 'react';

/**
 * 트랜잭션 데이터를 처리하는 고차 컴포넌트 (HOC)
 *
 * @param WrappedComponent 래핑할 컴포넌트
 * @param fetchHook 데이터를 가져오는 훅 함수
 * @param emptyMessage 데이터가 없을 때 표시할 메시지
 * @returns 트랜잭션 데이터를 처리하는 컴포넌트
 */
const withTransactionData = <P extends object>(
  WrappedComponent: FC<P>,
  fetchHook: (transaction: ProductInboundTransactionDoc | ProductOutboundTransactionDoc) => { data: any },
  emptyMessage: string
) => {
  const WithTransactionData: FC<{ transaction: ProductInboundTransactionDoc | ProductOutboundTransactionDoc }> = ({
    transaction,
  }) => {
    const { data } = fetchHook(transaction);

    if (!data) {
      return <Empty description={emptyMessage} />;
    }

    return <WrappedComponent {...(data as unknown as P)} />;
  };

  WithTransactionData.displayName = `withTransactionData(${
    WrappedComponent.displayName || WrappedComponent.name || 'Component'
  })`;

  return WithTransactionData;
};

export default withTransactionData;
